// Shared content/data for the site.
// ► Edit here to update copy, rates, tour dates, testimonials, etc.

export const BRAND = {
  name: 'Zahra Belle',
  nameShort: 'Zahra',
  tagline: 'Playful, passionate, authentic chemistry.',
  city: 'Melbourne, Australia',
  email: 'zahrabelle@protonmail.com',
  phone: '0481 979 326',
  phoneIntl: '+61 481 979 326',
  phoneLabel: 'SMS only · 0481 979 326',
  whatsapp: 'https://wa.me/61481979326',
  whatsappLabel: 'WhatsApp',
  instagram: 'https://www.instagram.com/zahrabellesbackagain/',
  instagramHandle: '@zahrabellesbackagain',
  bluesky: 'https://bsky.app/profile/zahrabelle',
  blueskyHandle: '@zahrabelle',
  // TODO: Zahra — replace this with your actual wishlist URL (Amazon, Throne, Giftfoyou, etc.)
  wishlist: 'https://throne.com/zahrabelle',
};

export const IMAGES = {
  hero: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/6qx6ia8b_ZB-2.jpg',
  about: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/y5ovb9dy_ZB-7.jpg',
  ratesAside: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/5zruchgq_ZB-5.jpg',
  parallax: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/duc9b2xt_ZB-10.jpg',
  homeQuote: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/icig1exa_ZB-15.jpg',
  gallery: [
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/6pjmatfm_ZB-1.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/2hlo9cty_ZB-3.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/18rx6ew9_ZB-4.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/r9qr66fs_ZB-6.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/c74epole_ZB-8.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/bxk4icjh_ZB-13.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/f5h7lu3v_ZB-14.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/icig1exa_ZB-15.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/fvpjcx15_ZB-11.webp',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/mrbrg8fe_ZB-12.webp',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/5zruchgq_ZB-5.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/duc9b2xt_ZB-10.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/y5ovb9dy_ZB-7.jpg',
    'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/6qx6ia8b_ZB-2.jpg',
  ],
};

// Physical stats from Scarlet Blue profile
export const STATS = [
  ['Location', 'Melbourne'],
  ['Age', "30's"],
  ['Height', '168 cm'],
  ['Dress', '10 · hourglass'],
  ['Body', 'Athletic'],
  ['Hair', 'Brunette'],
  ['Eyes', 'Green'],
  ['Ethnicity', 'White / Australian'],
];

export const FAVOURITES = [
  'Time in nature',
  'Outdoor baths',
  'Long degustations',
  'Winery tours',
  'Getting lost in a book',
  'Strength training',
  'Travel',
  'Scuba diving',
  'Multi-day hikes',
];

// Rates — structured as GFE / NGFE / VIP tiers (incall)
export const INCALL_TIERS = [
  { duration: '1 Hour', gfe: '$700', ngfe: '$800', vip: '$1,100', note: '' },
  { duration: '1.5 Hours', gfe: '$1,000', ngfe: '$1,100', vip: '$1,500', note: '' },
  { duration: '2 Hours', gfe: '$1,300', ngfe: '$1,500', vip: '$2,000', note: 'The unhurried sweet spot' },
  { duration: '3 Hours', gfe: '$1,900', ngfe: '$2,100', vip: '$2,900', note: '' },
];

export const EXPERIENCE_RATES = [
  {
    title: 'Dinner Date',
    duration: '4 hours',
    rate: '$2,000',
    blurb: 'Split evenly between eating and being eaten. My favourite way to begin a story.',
  },
  {
    title: 'Extended Dinner',
    duration: '6 hours',
    rate: '$2,900',
    blurb: 'Six hours, split evenly however we wish. Slower pace, longer conversations, a little more of everything.',
  },
  {
    title: 'Overnight',
    duration: '16 hours',
    rate: '$7,000',
    blurb: 'Sixteen hours, including seven hours of beauty sleep. Morning sex is the best kind.',
  },
  {
    title: '24 Hours',
    duration: '24 hours',
    rate: '$10,000',
    blurb: 'A full day and a full night. All of me, from breakfast to breakfast.',
  },
  {
    title: 'Weekend',
    duration: '48 hours',
    rate: '$15,000',
    blurb: 'A luxurious weekend. Two days, two nights, let\u2019s see how deep we can go.',
  },
  {
    title: 'Fly Me To You',
    duration: 'Overnight minimum',
    rate: 'from $5,000',
    blurb: 'Overnight minimum plus flights. A passport-ready indulgence, crafted to your itinerary.',
  },
  {
    title: 'Couples',
    duration: '2 hour minimum',
    rate: 'from $2,000',
    blurb: 'Curious about adding a third? You, your partner, and me. A softly-guided introduction to shared pleasure, unhurried and completely at your pace.',
  },
  {
    title: 'Doubles',
    duration: '1.5 hour minimum',
    rate: 'from $1,500 doubled',
    blurb: 'Want me to bring a friend? The m\u00E9nage \u00E0 trois of your dreams. I have a plethora of bisexual hotties for you to choose from in most cities.',
  },
  {
    title: 'Bespoke Itinerary',
    duration: 'Pairs with any booking',
    rate: '+ $500',
    blurb: 'Leave the planning to me: restaurants, accommodation, and activities curated to the occasion. You simply arrive, and fall into a world already set for you.',
  },
  {
    title: 'Outcall',
    duration: '2 hour minimum',
    rate: 'from $1,300',
    blurb: 'Want me to come to you? Additional $100 fee for inner city hotels. 2 hour minimum.',
  },
];

// Tier explanation — matching her new sales letter voice
export const TIER_NOTES = [
  [
    'GFE · Girlfriend Experience',
    'Your sweet, sensual girlfriend. Effortless, warm, and completely yours in the moment.',
  ],
  [
    'NGFE · Naughty Girlfriend',
    'Your cheeky girlfriend. Playful, teasing, and undeniably hot for you in all the right ways.',
  ],
  [
    'VIP NGFE',
    'My clients\u2019 favourite, for a reason. Unrestricted and indulgent, a beautifully curated luxury date where we let go and follow the chemistry, and create something truly unforgettable together.',
  ],
];

export const SERVICES = [
  'Girlfriend Experience (GFE)',
  'Dinner & lunch dates',
  'Overnight stays',
  'Travel Companion · Fly Me To You',
  'Affectionate kissing · DFK',
  'For Couples',
  'MFF · MMF · Bi twin (duo)',
  'Lesbian / Bi (F2F)',
  'Disability friendly',
  'Fetish · foot fetish · light spanking',
  'Mutual natural oral',
  'Multiple positions',
  'Rimming · strap on',
  'Passionate, unscripted play',
];

export const INTERESTS = [
  'Hiking & scuba diving',
  'Degustations with wine pairings',
  'Baths with a view',
  'Exploring new places',
  'Art in all its forms',
  'Japanese, French, cheese & chocolate',
  'Pinot Noir',
  'Peonies, roses & Australian natives',
];

// Handpicked from Scarlet Blue testimonials — real words from real clients
export const TESTIMONIALS = [
  {
    quote:
      'Zahra is unlike anyone I\u2019ve ever met. From the moment you\u2019re in her presence, everything else fades. She has that rare ability to make you feel like the only person in the world. Her beauty is striking, yes, but it\u2019s her warmth, her grace, and the way she connects so effortlessly that truly captivates.',
    author: 'Jason',
    date: 'May 2025',
  },
  {
    quote:
      'Easily some of the hottest sex I\u2019ve ever had. She\u2019s so cheeky and naughty and we had a lot of fun together. Can\u2019t wait to see her, and that perfect body, again.',
    author: 'Chris',
    date: 'March 2026',
  },
  {
    quote:
      'Put simply, Zahra is an absolute sweetheart. Always relaxed, smiling, and immediately makes me feel comfortable and at ease as soon as I sit down with her. She is as gorgeous as her lovely photos, and then some.',
    author: 'Jack',
    date: 'April 2026',
  },
  {
    quote:
      'Got a chance to make a booking with Zahra on her short tour in Adelaide and what a lovely time. Beautiful smile and the most beautiful green eyes I\u2019ve ever seen. She was all about making me comfortable, unrushed, and all about having a fun time.',
    author: 'Mitch',
    date: 'June 2026',
  },
  {
    quote:
      'I had the pleasure of meeting Zahra in Adelaide. From the start of our communication until she kissed me goodbye at the door, the experience was amazing. Zahra has a wonderful personality, amazing lips to kiss, and her loving is perfect. I look forward to seeing her again.',
    author: 'Ben',
    date: 'June 2026',
  },
  {
    quote:
      'An amazing breath of fresh air. A wonderful personality and a devilishly cheeky grin. I left feeling lighter than I had in years.',
    author: 'D.',
    date: 'November 2024',
  },
  {
    quote:
      'Great kissing made the atmosphere relaxed and sultry at the same time. Genuinely warm, genuinely present, and genuinely fun.',
    author: 'Bruce',
    date: 'October 2024',
  },
  {
    quote:
      'If they ask for the road to heaven, I will direct them to Zahra for sure. Beauty, body, and a serious commitment to the pleasure of the man in front of her.',
    author: 'BB',
    date: 'May 2025',
  },
  {
    quote:
      'I\u2019ve caught up with Zahra numerous times over the past year and I am blown away by her presence and her persistence to please. When graced by her charmingly cheeky nature, I have to hold myself back from awe knowing full well I\u2019m in for a wonderful time.',
    author: 'T',
    date: 'October 2025',
  },
  {
    quote:
      'What a delight it was to meet Zahra for the first time. She has a remarkable gift of being able to find you at your centre and encourage you to venture out a little, in the best possible way, while you discover new things about yourself. A beautiful human, a stunning companion.',
    author: 'Francis',
    date: 'November 2024',
  },
  {
    quote:
      'Hot, sweet and tender. What a time. Mesmerising kisser, you\u2019ll breathe slower while your heart races. Down to earth and an amazing ability to know what you want without saying a word.',
    author: 'Joel',
    date: 'April 2024',
  },
  {
    quote:
      'She is so lovely, once in a lifetime girl. Such a cute, friendly, caring soul. I wish her all the very best and would love to see her every time she visits.',
    author: 'Mick',
    date: 'September 2025',
  },
  {
    quote:
      'Zahra was AMAZING to say the least. It was great to see her while she was in Canberra, still finding it hard to forget her hours after our time together.',
    author: 'Mitch',
    date: 'April 2026',
  },
];

// Real tour dates from Scarlet Blue
export const TOUR_STOPS = [
  { city: 'Melbourne', dates: 'Home base · by appointment', status: 'home' },
  { city: 'Adelaide', dates: '10 – 12 August', status: 'taking-bookings' },
  { city: 'Singapore', dates: '20 – 22 September', status: 'taking-bookings' },
  { city: 'London', dates: '24 – 27 September', status: 'taking-bookings' },
];

export const TOUR_BANNER =
  'Now taking bookings · Adelaide 10–12 August · Singapore 20–22 September · London 24–27 September';

export const AVAILABILITY = {
  days: 'Monday through Sunday',
  hours: '9:00am – 9:00pm',
  note: 'By appointment. Pre-bookings preferred but I can sometimes be available on short notice. Flexible hours by appointment.',
};

export const BOOKING_CITIES = [
  'Melbourne',
  'Sydney',
  'Brisbane',
  'Perth',
  'Adelaide',
  'Canberra',
  'Hobart',
  'Darwin',
  'Singapore',
  'London',
  'Elsewhere (Fly Me To You)',
  'Not sure yet',
];

export const REFERRAL_SOURCES = [
  'Scarlet Blue',
  'Tryst',
  'Real Babes',
  'Instagram',
  'Peer recommendation',
  'Other',
];

export const DURATIONS = [
  '1 hour',
  '1.5 hours',
  '2 hours',
  '3 hours',
  'Dinner date (4h)',
  'Extended dinner (6h)',
  'Overnight (16h)',
  '24 Hours',
  'Weekend (48h)',
  'Fly Me To You',
];

export const BOOKING_TYPE_OPTIONS = [
  'GFE · Girlfriend Experience',
  'NGFE · Naughty Girlfriend',
  'VIP NGFE',
  'Dinner / lunch date',
  'Overnight',
  '24 Hours',
  'Weekend Away',
  'Fly Me To You',
  'Couples',
  'Doubles',
  'Duo',
  'Not sure yet',
];
